import React from 'react'

export const IconMessageDetails: React.FC = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_480_15629" maskUnits="userSpaceOnUse" x="0" y="1" width="24" height="23">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.799805 10.3C0.799805 5.49998 5.7998 1.59998 11.9998 1.59998C18.0998 1.59998 23.1998 5.49998 23.1998 10.3C23.1998 15 18.3998 18.8 12.4998 19L8.3998 23.3C8.0998 23.6 7.5998 23.7 7.1998 23.6C6.7998 23.4 6.4998 23 6.4998 22.5V18.1C3.0998 16.6 0.799805 13.5 0.799805 10.3ZM11.1998 17.1C11.3998 16.9 11.6998 16.8 11.9998 16.8C16.8998 16.8 20.8998 13.9 20.8998 10.4C20.8998 6.89997 16.8998 3.99998 11.9998 3.99998C7.0998 3.99998 3.0998 6.89997 3.0998 10.4C3.0998 12.8 4.9998 15.2 7.8998 16.3C8.2998 16.5 8.5998 16.9 8.5998 17.4V19.8L11.1998 17.1Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_480_15629)">
        <path d="M24 0H0V25H24V0Z" />
      </g>
    </svg>
  )
}
